import React from 'react';
import { connect } from 'react-redux';
import { deleteStore, loadStore } from '../store/editStoreActions';
import {
  Container,
  Col,
  Row,
  Table,
  Button,
  Jumbotron,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import './Home.css';
import { getStores } from '../store/storesActions';
import AddStore from '../components/AddStore/AddStore';
import { IconEdit, IconPlus, IconRemove } from '../components/Icons/Icons';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddStore: false,
      deleteModalIsOpen: false,
      activeStoreId: null,
      activeStoreName: null
    };
  }

  componentDidMount() {
    this.props.getStores();
  }

  toggleDeleteModal(activeStoreId, activeStoreName) {
    this.setState({
      deleteModalIsOpen: !this.state.deleteModalIsOpen,
      activeStoreId,
      activeStoreName
    });
  }

  render() {
    const { stores } = this.props;
    const { deleteModalIsOpen, activeStoreId, activeStoreName } = this.state;
    return (
      <Container>
        <Jumbotron className="text-center py-3 pt-4">
          <h1 className="mb-3">Stores</h1>
          <div className="header-buttons">
            <Button
              color="primary"
              onClick={() => {
                this.setState({ showAddStore: true });
              }}
            >
              <IconPlus />
              <span>Create new store</span>
            </Button>
          </div>
          <AddStore
            show={this.state.showAddStore}
            onClose={() => {
              this.setState({ showAddStore: false });
            }}
          />
        </Jumbotron>

        <Row>
          <Col number={6}>
            <Table hover className="stores-table">
              <colgroup>
                <col width="200" />
                <col width="200" />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>Store name</th>
                  <th>ID</th>
                  <th>Edit store</th>
                  <th className="text-right">Remove store</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(stores).map(store => {
                  return (
                    <tr key={store.id} className={'align-middle'}>
                      <td>{store.name}</td>
                      <td>{store.id}</td>
                      <td>
                        <Button
                          color="primary"
                          outline
                          onClick={() => {
                            this.props.loadStore(store.id, store.name, 'test');
                          }}
                        >
                          <IconEdit /> <span>Test</span>
                        </Button>
                        <Button
                          color="primary"
                          outline
                          onClick={() => {
                            this.props.loadStore(
                              store.id,
                              store.name,
                              'production'
                            );
                          }}
                        >
                          <IconEdit /> <span>Production</span>
                        </Button>
                      </td>
                      <td className="text-right">
                        <Button
                          color="danger"
                          outline
                          onClick={() => {
                            this.toggleDeleteModal(store.id, store.name);
                          }}
                          title="Remove store"
                        >
                          <IconRemove /> <span>Remove</span>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Modal isOpen={deleteModalIsOpen} toggle={this.toggleDeleteModal}>
          <ModalHeader>Remove store</ModalHeader>
          <ModalBody className="p-4 text-center">
            Are you sure you want to remove the {activeStoreName} store?
          </ModalBody>
          <ModalFooter>
            <Button
              color={'primary'}
              onClick={() => {
                this.props.deleteStore(activeStoreId);
                this.toggleDeleteModal();
              }}
            >
              Remove store
            </Button>
            <Button
              color={'link'}
              onClick={() => {
                this.toggleDeleteModal();
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = ({ stores }) => ({
  stores: stores.stores
});

const mapDispatchToProps = dispatch => ({
  loadStore: (storeId, name, env) => {
    dispatch(loadStore(storeId, name, env));
  },
  getStores: () => {
    dispatch(getStores());
  },
  deleteStore: id => {
    dispatch(deleteStore(id));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js